import { z } from 'zod';
import { FilterType_S } from './filterType.schema';

/**
 * COMMON FILTER CONFIG
 */
export const CommonFilterConfiguration_S = z.object({
    showCollapsed: z.boolean(),
    order: z.number(),
    showFrom: z.boolean().optional(),
    showTo: z.boolean().optional(),
    maxValues: z.number().optional(),
    sorting: z.union([z.literal('count'), z.literal('alphabet')]).optional(),
    defaultChecked: z.boolean().optional(),
    checkboxDescription: z.string().optional(),
    unit: z.string().optional(),
    valuesLogic: z.union([z.literal('AND'), z.literal('OR')]).optional(),
    subtype: z.string().optional(),
    hasSearchInput: z.boolean().optional(),
});

export const CommonFilter_Config_S = z.object({
    identifier: z.string(),
    name: z.string(),
    type: FilterType_S,
    configuration: CommonFilterConfiguration_S,
});

/**
 * COMMON FILTER STATE
 */
export const CommonFilter_State_S = z.object({});

/**
 * COMMON FILTER REQUEST PARAMS
 */
export const CommonFilter_RequestParams_S = z.object({
    name: z.string(),
});
